<template>
  <FormModal :header="modalHeader" :name="name" @hide="handleHideModal">
    <FormModalBody
      footer-button-text="Save"
      @submit="saveForm"
      :is-button-loading="form.processing"
    >
      <FormSelectWithGroupsDropdown
        v-model="form.templateIndustryId"
        :groups="$page.props.industrySpecialties"
        is-required
        :is-error="Boolean(form.errors.template_industry_id)"
        :errors="form.errors.template_industry_id"
        @update:model-value="form.clearErrors('template_industry_id')"
        placeholder="Select industry"
      >
        <template #label>Industry</template>
      </FormSelectWithGroupsDropdown>
      <FormInput
        v-model="form.description"
        :is-error="Boolean(form.errors.description)"
        :errors="form.errors.description"
        @input="form.clearErrors('description')"
        class="tw-mt-4"
        as="textarea"
        rows="4"
        placeholder="Describe your experience..."
        is-required
        test_id="industry-description-input"
        :min-characters="150"
        :max-characters="500"
      >
        <template #label>Description</template>
      </FormInput>
    </FormModalBody>
  </FormModal>
</template>

<script setup>
import _capitalize from 'lodash/capitalize'
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import FormInput from '@/shared/components/forms/FormInput.vue'
import { useForm } from '@inertiajs/vue3'
import FormSelectWithGroupsDropdown from '@/shared/components/forms/FormSelectWithGroupsDropdown.vue'
import snakeCaseKeys from 'snakecase-keys'
import { computed } from 'vue'
import { useModals } from '@/shared/composables/useModals.js'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  mode: {
    type: String,
    required: true,
    validator: function (value) {
      return ['EDIT', 'ADD'].includes(value.toUpperCase())
    },
  },
  industry: {
    type: Object,
    default: () => ({
      templateIndustryId: null,
      description: null,
    }),
  },
})

const { closeModal } = useModals()

const form = useForm({ ...props.industry })

const modalHeader = computed(() => {
  return `${_capitalize(props.mode)} industry`
})

const saveForm = () => {
  const method = props.mode === 'EDIT' ? 'patch' : 'post'
  const url =
    props.mode === 'EDIT'
      ? `/profile/mentor/industry_specialties/${props.industry.id}`
      : '/profile/mentor/industry_specialties'

  form
    .transform((data) => ({
      industry_specialty: snakeCaseKeys(data),
    }))
    [method](url, {
      preserveScroll: true,
      onSuccess: () => {
        closeModal(props.name)
      },
    })
}

const handleHideModal = () => {
  if (props.mode === 'ADD') {
    form.reset()
  }
}
</script>
